import type { WhereFilterOp } from 'firebase/firestore';

import type { FirebaseServices } from './app.ts';

export type Filter = [field: string, op: WhereFilterOp, value: unknown];

// Public or rule-checked reads of a collection.
export async function queryDocuments(
  services: FirebaseServices,
  collectionName: string,
  { filters = [], orderBy, limit = 50 }: { filters?: Filter[]; orderBy?: [field: string, direction: 'asc' | 'desc']; limit?: number } = {},
): Promise<{ id: string; data: Record<string, unknown> }[]> {
  const [firestoreModule, firestore] = await Promise.all([import('firebase/firestore'), services.firestore()]);
  const { collection, getDocs, limit: limitTo, orderBy: order, query, where } = firestoreModule;
  const constraints = [
    ...filters.map(([field, op, value]) => where(field, op, value)),
    ...(orderBy ? [order(orderBy[0], orderBy[1])] : []),
    limitTo(limit),
  ];
  const snapshot = await getDocs(query(collection(firestore, collectionName), ...constraints));
  return snapshot.docs.map(item => ({ id: item.id, data: item.data() }));
}

// How many documents match, counted by Firestore without reading them.
export async function countDocuments(services: FirebaseServices, collectionName: string, filters: Filter[]): Promise<number> {
  const [firestoreModule, firestore] = await Promise.all([import('firebase/firestore'), services.firestore()]);
  const { collection, getCountFromServer, query, where } = firestoreModule;
  const snapshot = await getCountFromServer(query(collection(firestore, collectionName), ...filters.map(([field, op, value]) => where(field, op, value))));
  return snapshot.data().count;
}
